import { Fragment } from "react"
import CreationModal from "../components/modals/CreationModal"
import OrbitalInsightsModal from "../components/modals/orbital-insights/OrbitReportWindow"
import PresimReportWindow from "../components/modals/presim/PresimReportWindow"
import SatelliteSelectionModal from "../components/modals/satellite/SatelliteSelectionModal"
import OrbitConfigModal from "../components/modals/satellite/OrbitConfigModal"
import TaskPlanModal from "../components/modals/schedule/TaskPlanModal"
import FaultSelectionModal from "../components/modals/faults/FaultSelectionModal"
import ConfirmationModal from "../components/modals/confirmation/ConfirmationModal"
import HwilComponentSelectionModal from "../components/modals/hwil/HwilComponentSelectionModal"
import PayloadConfigModal from "../components/modals/hwil/PayloadConfigModal"
import ScheduleReportModal from "../components/modals/schedule/ScheduleReportWindow"
import FaultsReportWindow from "../components/modals/faults/FaultsReportWindow"
import AllPresimReportWindows from "../components/modals/presim/AllPresimReportWindows"
import AllOrbitalInsightsDetails from "../components/modals/orbital-insights/AllOrbitalInsightsDetails"
import ThermalHeatMap from "../components/scenario-timeline/thermal-heatmap/ThermalHeatMap"


const ModalProviders = ({ children }: { children: React.ReactNode }) => {
    return (
        <Fragment>
            <CreationModal />
            <SatelliteSelectionModal />
            <OrbitConfigModal />
            <PayloadConfigModal />
            <HwilComponentSelectionModal />
            <TaskPlanModal />
            <FaultSelectionModal />
            <PresimReportWindow />
            <AllPresimReportWindows />
            <AllOrbitalInsightsDetails />
            <ScheduleReportModal />
            <FaultsReportWindow />
            <OrbitalInsightsModal />
            <ThermalHeatMap />
            <ConfirmationModal />
            {children}
        </Fragment>
    )
}

export default ModalProviders